/**
 * Updates the disabled reason for approve/reject buttons
 * @param selectedRows Selected rows in the grid
 * @param action The action (approve or reject)
 * @returns The reason string or null
 */
export const updateDisabledReason = (
  selectedRows: any[], 
  action: 'approve' | 'reject', 
  setDisabledReason: (reason: string | null) => void
) => {

  let reason: string | null = null;
  if (selectedRows.length === 0) {
    reason = `Please select one or more records before ${action === 'approve' ? 'approving' : 'rejecting'}.`;
  }

  setDisabledReason(reason);
};

  // Helper: read deeplink if prop not provided
export const parseDeepLinkFromUrl = () => {
    const qs = new URLSearchParams(window.location.search);
    const recordId = qs.get("recordId") || undefined;
    const action = qs.get("action") || undefined;
    return recordId || action ? { recordId, action } : undefined;
  };